<template>
    <div class="infoengine relationship-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Relationship Length Factor</h2>
                </div>
                <div class="col-md-7 text-right filter-fields">
                    <div class="row">
                        <div class="col-md-5">
                            <base-search
                                placeholder="Search relationship length"
                                @keyword="getKeyword"
                            ></base-search>
                        </div>
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-3">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="apply"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-9">
                                    <b-button
                                        type="button"
                                        variant="secondary"
                                        class="secondary-add-btn"
                                        @click="
                                            $bvModal.show(
                                                'add-relationship-popup'
                                            )
                                        "
                                    >
                                        <span class="btn-text"
                                            >+ Add Relationship Length</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="[
                'table-section',
                'tablet-table-xxs-min-width',

                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="monthRange" slot-scope="data">
                    <span>{{ data.value.minimum }} months to </span>

                    <span>{{ data.value.maximum }} months</span>
                </template>
                <template slot="rating" slot-scope="data">
                    <base-status :status-type="data.value"></base-status>
                </template>
                <template slot="status" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-relationship-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            :icon="
                                data.value == 'active'
                                    ? 'icon-trash'
                                    : 'icon-done'
                            "
                            :label="
                                data.value == 'active' ? 'Archive' : 'Activate'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('status-update-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
        </div>
        <!-- Get list records -->
        <base-records
            path="configurations/relationships"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <!-- Add relationship popup -->
        <add-relationship-popup
            :title="title"
            :button-text="buttonText"
        ></add-relationship-popup>
        <!-- Archive popup -->
        <archive-popup
            title="Archive Relationship Length Factor"
            description="Are you sure you want to archive this relationship length factor? You can re-activate it later."
        ></archive-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addRelationshipPopup from '@/components/popups/AddRelationshipPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
export default {
    components: {
        addRelationshipPopup,
        archivePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            fields: [
                {
                    key: 'monthRange',
                    label: 'Rule',
                    sortable: true,
                },
                {
                    key: 'title',
                    label: 'Relationship Length Title',
                    sortable: true,
                },
                {
                    key: 'rating',
                    label: 'rating',
                    sortable: true,
                    class: 'w-230px text-center',
                },
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list w-300px text-center',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'monthRange',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            title: '',
            buttonText: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
